import axios from 'axios';

const API_URL = process.env.VUE_APP_BASE_API_URL_OSINT;

class FacebookService {
    search(data) {
        return axios.post(API_URL+'facebook/get-profile', data);
    }
    getPostUser(data) {
        return axios.post(API_URL+'facebook/get-post', data);
    }
    getDetailPost(data) {
        return axios.post(API_URL+'facebook/get-detail-post', data);
    }
}

export default new FacebookService();
